<span *ngIf="!data.isListing;else listing">
    <div mat-dialog-title class="confirmHeader p-2 d-flex justify-content-center">
        <h3 class="header">{{data.header}}</h3>
    </div>
    <ol style="height: calc(70vh - 127px); overflow-y: scroll;">
        <li *ngFor="let instruction of data.message; let i = index" style="margin-bottom: 1rem;">
            <span [innerHTML]="getSanitizedInstruction(instruction.Instruction)"></span>
        </li>
    </ol>

    <app-button buttonclass="primary" customClass="instructions-btn" class="d-flex pb-2 justify-content-center"
        (click)="onNoClick()">{{data.continue}}</app-button>
</span>

<ng-template #listing>
    <app-templates-listing [gridHeader]="data?.ListedGridHeader" [gridData]="data.gridData"
    [context]="data?.header" [popupCloseRequired]="true" >
</app-templates-listing>
</ng-template>